import React from 'react';
import { ClientsTable } from 'components/table/user_management/clients/ClientsTable';

const Clients: React.FC = () => {
    return <ClientsTable />;
};

export { Clients };
